
import {getLanguageConfig, getConfig} from "../../utils/config-helper";
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';

export default defineComponent({
    name: "CalendarDate",
    props: {
        day: {
            type: Object,
            required: true
        },
        selectDate: {
            type: Function
        },
        isSelectedStartDay: {
            type: Boolean
        },
        isSelectedEndDay: {
            type: Boolean
        },
        isDisabled: {
            type: Boolean
        },
        hasDisabledLook: {
            type: Boolean
        },
        isInRange: {
            type: Boolean
        },
        isTimeList: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false,
            default: "ticket"
        },
        hideTendency: {
            type: Boolean,
            required: false,
            default: false
        },
        hideSeason: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['selectDate'],
    setup(props, {emit}) {

        const isMobile = matchMedia('(max-width: 767px)').matches;

        //console.log(props);
        //console.log(props.day.soldOut);
        //console.log(props.day.disabled);

        const getDay = (date) => {
            //get day (number) of date
            return new Date(date).toLocaleDateString(getLanguageConfig(), {day: 'numeric'});
        };

        const getPriceTendencyName = (priceTendency) => {
            return getConfig('priceTendencyLegend')[priceTendency];
        }

        const getPriceTendencyStatus = computed(() => {
            return 'status--' + props.day.priceTendency;
        });

        const getMobilePriceTendency = () => {
            if(props.day.priceTendency === 'low') {
                return 'L3';
            } else if(props.day.priceTendency === 'rather-low') {
                return 'L2';
            } else if(props.day.priceTendency === 'normal') {
                return 'L1';
            } else {
                return false;
            }
        }

        const getSoldout = () => {
             return props.day.soldOut && props.day.disabled;
        }

        const hasAvailabilities = () => {
            if (!props.day.soldOut && !props.day.disabled) {
                return true;
            }
        }

        const selectDate = (date) => {
            emit('selectDate', date.date);
        }

        return {
            getDay,
            selectDate,
            getPriceTendencyStatus,
            getMobilePriceTendency,
            getPriceTendencyName,
            isMobile,
            getSoldout,
            hasAvailabilities,
            translate
        }
    }
});
